const apiBaseUrl = 'http://localhost:5000';
// const apiBaseUrl = 'https://staging1.nimiprojects.in/ledgerapi';

//---------------------------------------------------------------------------------------------------------
export const contactUs = apiBaseUrl+'/postContactUsForm';